import { colors } from 'styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
  a {
    color: ${colors.ink};
    text-decoration: none;

    &:hover {
      color: ${colors.sea};
    }
  }

  ${({ desktop }) =>
    desktop
      ? `
			align-items: center;
			display: flex;
			font-size: 1.125rem;

			@media (max-width: 991px) {
					display: none;
			}

			> * {
					margin-right: 2.5rem;

					&:last-child {
							margin-right: unset;
					}
			}
		`
      : `
			padding: 3rem;
			display: flex;
			flex-direction: column;
			font-size: 1.125rem;

			> * {
					margin-bottom: 1rem;

					&:last-child {
							margin-bottom: unset;
					}
			}
	`}
`;
